import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import { isValidUrl } from '../../../utils/methods/helpers';
import Anchor from '../../Anchor';
import Timestamp from './Timestamp';
import COLORS from '../../../utils/constants/colors';

const styles = {
  anchor: {
    color: COLORS.WHITE,
    fontSize: 'inherit',
  },
};

const FreeTextDisplay = ({
  classes,
  content,
  completed,
  timestamp,
  linkText,
}) => {
  return (
    <div>
      {content && isValidUrl(content) && linkText ? (
        <Anchor
          text={linkText}
          target="_blank"
          className={classes.anchor}
          href={content}
        />
      ) : (
        content
      )}
      {completed && timestamp && <Timestamp value={timestamp} />}
    </div>
  );
};

FreeTextDisplay.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.object,
  content: PropTypes.string,
  completed: PropTypes.bool,
  timestamp: PropTypes.string,
  linkText: PropTypes.string,
};

export default withStyles(styles)(FreeTextDisplay);
